import { useContext, useEffect, useCallback, useRef, useState } from 'react';
import { differenceInSeconds, format, formatDistanceStrict } from 'date-fns';
import ViewportContext from '@atlassian/jira-software-deployments-common-table/src/components/table/common/context/viewport/context';

const SECONDS_IN_A_DAY = 86400;

export const useSlideOut = () => {
	const { listenToViewportScroll, stopListeningToViewportScroll, requestViewportScrollBounding } =
		useContext(ViewportContext);
	const [slideOut, setSlideOut] = useState<unknown>(null);
	const initialScrollRef = useRef<unknown>(null);
	const onScroll = useCallback(() => {
		const { scrollLeft, scrollTop } = requestViewportScrollBounding();
		if (!initialScrollRef.current) {
			initialScrollRef.current = {
				initScrollLeft: scrollLeft,
				initScrollTop: scrollTop,
			};
		}
		// @ts-expect-error - TS2339 - Property 'initScrollLeft' does not exist on type 'unknown'. | TS2339 - Property 'initScrollTop' does not exist on type 'unknown'.
		const { initScrollLeft, initScrollTop } = initialScrollRef.current;
		const directionX = initScrollLeft - scrollLeft;
		const directionY = initScrollTop - scrollTop;
		const THRESHOLD = 20;
		if (slideOut === null) {
			if (directionX > THRESHOLD) {
				setSlideOut('RIGHT');
			} else if (directionX < -THRESHOLD) {
				setSlideOut('LEFT');
			} else if (directionY > THRESHOLD) {
				setSlideOut('UP');
			} else if (directionY < -THRESHOLD) {
				setSlideOut('UP');
			}
		}
	}, [requestViewportScrollBounding, setSlideOut, slideOut]);
	useEffect(() => {
		if (slideOut !== null) {
			stopListeningToViewportScroll(onScroll);
		}
	}, [onScroll, slideOut, stopListeningToViewportScroll]);

	useEffect(() => {
		listenToViewportScroll(onScroll);

		return () => {
			stopListeningToViewportScroll(onScroll);
		};
	}, [listenToViewportScroll, onScroll, stopListeningToViewportScroll]);

	return slideOut;
};

export const formatDeploymentDate = (currentDate: Date, lastUpdatedDate: Date): string => {
	const isDateFormatRelative =
		differenceInSeconds(currentDate, lastUpdatedDate) <= SECONDS_IN_A_DAY;

	return isDateFormatRelative
		? formatDistanceStrict(lastUpdatedDate, currentDate, {
				addSuffix: true,
				roundingMethod: 'floor',
			})
		: format(lastUpdatedDate, 'd MMM, HH:mm');
};
